// Role
export const STUDENT = 1;
export const TEACHER = 2;
export const ADMIN = 3;

// Practice Quiz type
export const QUIZ_TYPE_KANJI_QUIZ = 1;
export const QUIZ_TYPE_PARTICLE_QUIZ = 2;
export const QUIZ_TYPE_AUDIO_QUIZ = 3;
export const QUIZ_TYPE_CHARACTER_QUIZ = 4;
export const QUIZ_TYPE_VOCABULARY_QUIZ = 12;
// Kana Practice type
export const TYPE_PRACTICE_HIRAGANA = 5;
export const TYPE_PRACTICE_KATAKANA = 6;
// Teacher created quiz(test) type
export const TEACHER_CREATED_QUIZ_TYPE_KANJI_QUIZ = 7;
export const TEACHER_CREATED_QUIZ_TYPE_PARTICLE_QUIZ = 8;
export const TEACHER_CREATED_QUIZ_TYPE_AUDIO_QUIZ = 9;
export const TEACHER_CREATED_QUIZ_TYPE_CHARACTER_QUIZ = 10;
export const TEACHER_CREATED_QUIZ_TYPE_VOCABULARY_QUIZ = 13;
// Profeciency Test
export const QUIZ_TYPE_PROFICIENCY_TEST = 11;

export const STAGE_MODE_QUIZ_TYPE = 14;

// Check Test Quiz
export const QUIZ_TYPE_CHECK_TEST = 15;

// Student quiz status(exam students status)
export const STUDENT_QUIZ_STATUS_NOT_SUBMITTED = 0;
export const STUDENT_QUIZ_STATUS_SUBMITTED = 1;

// Exam status
export const EXAM_STATUS_NOT_STARTED = 0;
export const EXAM_STATUS_IN_PROGRESS = 1;
export const EXAM_STATUS_ENDED = 2;

// Exam history types
export const EXAM_TYPE_PRACTICE = 1;
export const EXAM_TYPE_TEST = 2;
export const EXAM_TYPE_PROFICIENCY = 3;

// Quiz title (practice)
export const QUIZ_TITLE_KANJI_QUIZ = 'かんじクイズ';
export const QUIZ_TITLE_PARTICLE_QUIZ = 'じょしクイズ';
export const QUIZ_TITLE_AUDIO_QUIZ = 'おとでチャレンジ';
export const QUIZ_TITLE_CHARACTER_QUIZ = 'もじでチャレンジクイズ';
export const QUIZ_TITLE_VOCABULARY_QUIZ = '単語クイズ';
// Quiz title (test)
export const QUIZ_TITLE_KANJI_TEST = 'かんじクイズ';
export const QUIZ_TITLE_PARTICLE_TEST = 'じょしクイズ';
export const QUIZ_TITLE_AUDIO_TEST = 'おとでチャレンジ';
export const QUIZ_TITLE_CHARACTER_TEST = 'もじでチャレンジ';
export const QUIZ_TITLE_VOCABULARY_TEST = '単語クイズ';
// Profeciency Test
export const QUIZ_TITLE_PROFICIENCY_TEST = '実力テスト';
export const QUIZ_TITLE_CHECK_TEST = 'チェックテスト';

export const QUIZ_POINTS_PER_QUESTION = 1;
export const QUIZ_TOTAL_POINT = 10;
export const QUIZ_TOTAL_POINT_STAGE_MODE = 20;
export const PROFICIENCY_TEST_TOTAL_POINT = 30;
export const CHECK_TEST_TOTAL_POINT = 40;

export const ORGANIZATION_TYPE_SCHOOL = 1;
export const ORGANIZATION_TYPE_COMPANY = 2;
export const ORGANIZATION_TYPE_HIGH_SCHOOL = 3;

export const TYPE_PRACTICE_HIRAGANA_TITLE = 'ひらがなれんしゅう';
export const TYPE_PRACTICE_KATAKANA_TITLE = 'カタカナれんしゅう';
